import cx from 'classnames';

import {Icon, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {EmptyNoticeProps} from './EmptyNotice.types';

/**
 * This component is used to render a generic empty message, and is used as part
 * of the empty state on some pages.
 */
export const EmptyNotice = ({
  className,
  icon = 'CircleDashed',
  title = 'Stay tuned…',
  body,
  ...otherProps
}: EmptyNoticeProps) => (
  <div
    className={cx(sprinkles({dir: 'col', flex: 'flex', gap: 40, items: 'center'}), className)}
    {...otherProps}>
    <div
      className={sprinkles({
        bg: 'concrete',
        content: 'center',
        flex: 'flex',
        items: 'center',
        radius: 'circle',
        size: 128,
      })}>
      <Icon name={icon} color="dustyGray" size={74} weight="thin" />
    </div>

    <div className={sprinkles({dir: 'col', flex: 'flex', gap: 16})}>
      {title && (
        <Text as="h2" color="doveGray" textAlign="center" variant="heading3">
          {title}
        </Text>
      )}

      {body && (
        <Text as="p" color="doveGray" textAlign="center">
          {body}
        </Text>
      )}
    </div>
  </div>
);
